import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import IconHelpOutlineSvg from '../../assets/icons/icon-help-outline.svg?react';
import LogoMarkSvg from '../../assets/logos/logo-mark.svg?react';

import { AppLanguageSelector } from './app-language-selector';
import { BaseButton } from './base-primitives.styles';

const TopBar = styled.header.attrs({
  'data-ui': 'tip-flow-top-bar',
})`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ theme }) => theme.scale.px(12)};
`;

const BrandCluster = styled.div`
  display: grid;
  align-content: start;
  gap: ${({ theme }) => theme.scale.px(3)};
`;

const LogoMark = styled(LogoMarkSvg)`
  width: ${({ theme }) => theme.scale.px(108)};
  height: ${({ theme }) => theme.scale.px(31)};
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};
  --logo-mark-accent: ${({ theme }) => theme.colors.brand.primary};
`;

const BrandTagline = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(8)};
  font-weight: 600;
  line-height: 1.18;
`;

const ActionsRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.scale.px(9)};

  & > [data-ui='shared-app-language-selector'] {
    margin-top: ${({ theme }) => theme.scale.px(7)};
  }
`;

const SupportButton = styled(BaseButton)`
  width: ${({ theme }) => theme.scale.px(39)};
  height: ${({ theme }) => theme.scale.px(39)};
  display: grid;
  place-items: center;
`;

const SupportIcon = styled(IconHelpOutlineSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: 100%;
  height: 100%;
  display: block;
  --help-icon-bg: ${({ theme }) => theme.colors.support.infoSubtle};
  --help-icon-fg: ${({ theme }) => theme.colors.text.primary};
`;

export function TipFlowTopBar() {
  const { t } = useTranslation();

  return (
    <TopBar>
      <BrandCluster>
        <LogoMark aria-label="grato" role="img" />
        <BrandTagline>{t('homeDashboard.brandTagline')}</BrandTagline>
      </BrandCluster>

      <ActionsRow>
        <AppLanguageSelector />
        <SupportButton
          aria-label={t('myPage.helpAria')}
          type="button"
          onClick={() => undefined}
        >
          <SupportIcon />
        </SupportButton>
      </ActionsRow>
    </TopBar>
  );
}
